import { TenantContext } from '@/components';
import { SortDirection } from '@/components/Table/types';
import { processesRepo } from '@/constants/providers';
import { UserProcess } from '@/modules/Processes/domain';
import { DataWithPagination } from '@/shared/types';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { ProcessKey } from './keys';

export const useGetProcessesByUser = (
  userId: number,
  pageNumber?: number,
  filter?: string,
  sortBy?: string,
  sortOrder?: SortDirection,
  options?: UseQueryOptions<
    DataWithPagination<UserProcess[]>,
    any,
    DataWithPagination<UserProcess[]>
  >,
) => {
  const { currentSelectedTenant } = useContext(TenantContext);

  return useQuery<DataWithPagination<UserProcess[]>>(
    [
      ...ProcessKey.BY_USER_PAGED(userId, {
        pageNumber,
        filter,
        sortBy,
        sortOrder,
      }),
      currentSelectedTenant?.id,
    ],
    () =>
      processesRepo.getProcessesByUser(
        userId,
        pageNumber,
        filter,
        sortBy,
        sortOrder,
      ),
    options,
  );
};
